import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { CheckboxWebElement } from './CheckboxWebElement';
export { CheckboxWebElement };

/**
 * Retrieve an instance of [CheckboxWebElement](../classes/CheckboxWebElement.html).
 * @example
 * ```javascript
 * import { findCheckbox } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findCheckbox(driver, By.id('my-oj-c-checkbox'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findCheckbox(driver: DriverLike, by: By): Promise<CheckboxWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type CheckboxWebElement
  if (!(webEl instanceof CheckboxWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'CheckboxWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findCheckbox(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${CheckboxWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-checkbox', CheckboxWebElement);
